// extracted by mini-css-extract-plugin
export default {"pending":"PendingData_pending__35xUZ"};